/** Посилання статті: rec:модуль/ід або rec:модуль/тип/ід — запис платформи; http(s) і mailto — зовнішні; решта (javascript: тощо) — відкидається. */
export function mdHref(href: string): { kind: 'record'; module: string; rt: string; id: string } | { kind: 'external'; url: string } | null {
  if (href.startsWith('rec:')) {
    const parts = href.slice(4).split('/').filter(Boolean);
    if (parts.length === 2) return { kind: 'record', module: parts[0]!, rt: parts[0]!, id: parts[1]! };
    if (parts.length === 3) return { kind: 'record', module: parts[0]!, rt: parts[1]!, id: parts[2]! };
    return null;
  }
  return /^(https?:|mailto:)/i.test(href) ? { kind: 'external', url: href } : null;
}
